import { useEffect } from 'react';
import { Route } from 'framework/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { Routes } from 'react-router-dom';
import { INTERVIEW_SCHEDULING_PATH, useInterviewSchedulingRoute, useInterviewSchedulingToken } from './routing';

const DAVINCI_CANDIDATE_PUBLIC = process.env.REACT_APP_DAVINCI_CANDIDATE_PUBLIC_FRONTEND_URL;

const RedirectPage = () => {
  const token = useInterviewSchedulingToken();
  useEffect(() => {
    window.location.replace(`${DAVINCI_CANDIDATE_PUBLIC}/interview-scheduling/${token}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

const PublicInterviewSchedulingRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { singleEntityRoute } = useInterviewSchedulingRoute();

  return (
    <Routes>
      <Route path={singleEntityRoute} element={<RedirectPage />} />

      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

PublicInterviewSchedulingRouter.getRouterPath = () => `${INTERVIEW_SCHEDULING_PATH}/*`;

export default PublicInterviewSchedulingRouter;
